<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { Message } from "@shared/types/Message";

  const dispatch = createEventDispatcher();

  function close() {
    dispatch("close");
  }

  export let message: Message;

  function closeNonDismissibleAlert() {
    if (!message.dismissible) {
      return close();
    }
  }

  function escaped(message, key) {
    if (message.rawHtml) {
      return message[key];
    } else {
      return message[key].replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
  }
</script>

<div
  class="fizz-alert-{message.type}{message.small ? ' fizz-alert--small' : ''}"
  on:click={closeNonDismissibleAlert}
>
  {#if message.dismissible}
    <a
      href={"#"}
      on:click={close}
      class="fizz-icon-button-small fizz-close-button"
      data-testid="dismissable-button"
    >
      <Icon width="12" height="12" type="X" className="fizz-icon-12 fizz-text-brand" />
    </a>
  {/if}
  {#if message.compact}
    <p>
      {#if message.header}
        <strong>{@html escaped(message, "header")}</strong>
      {/if}
      {#if message.message}
        {@html escaped(message, "message")}
      {/if}
    </p>
  {:else}
    {#if message.header}
      <p><strong>{@html escaped(message, "header")}</strong></p>
    {/if}
    {#if message.message}
      <p>{@html escaped(message, "message")}</p>
    {/if}
  {/if}
</div>
